module.exports = __webpack_public_path__ + "img/memry_all.550b3a45.png";